const Rolesmodule = [
  {
    id: 1,
    module: "Staff",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  // {
  //   id: 2,
  //   module: "Project",
  //   viewglobal: 0,
  //   view: 0,
  //   add: 0,
  //   edit: 0,
  //   delete: 0,
  //   isViewglobal: true,
  //   isAdd: true,
  //   isEdit: true,
  //   isDelete: true,
  // },
  {
    id: 3,
    module: "Roles and Permissions",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 4,
    module: "Customers",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 5,
    module: "Document Types",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 6,
    module: "Audit Logs",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    id: 7,
    module: "Categories",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 8,
    module: "Queries",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isViewglobal: false,
    isAdd: false,
    isEdit: true,
    isDelete: false,
  },
]

export default Rolesmodule
